import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3e8cf46"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cv-eyebrow mb-1" }, "Adminisztráció", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-h6 mb-6" }, "Bejelentkezés", -1))
const _hoisted_3 = { class: "d-flex justify-end mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_AuthLayout = _resolveComponent("AuthLayout")!

  return (_openBlock(), _createBlock(_component_AuthLayout, { "max-width": 448 }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createVNode(_component_v_form, {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onLogin()), ["prevent"]))
      }, {
        default: _withCtx(() => [
          (_ctx.sessionExpired)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                type: "info",
                variant: "tonal",
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" A munkameneted lejárt, jelentkezz be újra. ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.errorMessage)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 1,
                type: "error",
                variant: "tonal",
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            label: "Email cím",
            "prepend-inner-icon": "mdi-email-outline",
            autofocus: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            label: "Jelszó",
            "append-inner-icon": _ctx.visible ? 'mdi-eye-off' : 'mdi-eye',
            type: _ctx.visible ? 'text' : 'password',
            "prepend-inner-icon": "mdi-lock-outline",
            "onClick:appendInner": _ctx.toggleVisibility
          }, null, 8, ["modelValue", "append-inner-icon", "type", "onClick:appendInner"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              class: "cv-link text-caption",
              to: "/forgot-password?admin"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Elfelejtett jelszó? ")
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_v_btn, {
            color: "primary",
            size: "large",
            block: "",
            type: "submit",
            loading: _ctx.loading,
            disabled: _ctx.loading
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Bejelentkezés ")
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}